import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { Action } from '../../actions';
import { AppType } from './reducer';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';
import { initializeMultiAppAuthentication } from '../MultiAppAuthentication/actions';

export enum AppInfosActionKeys {
	ACCEPT_COOKIE = '@@app/ACCEPT_COOKIE',
	SET_APP_TYPE = '@@app/SET_APP_TYPE'
}

interface AcceptCookieAction extends Action {
	type: AppInfosActionKeys.ACCEPT_COOKIE;
}

interface SetAppTypeAppAction extends Action {
	type: AppInfosActionKeys.SET_APP_TYPE;
	appType: AppType;
}

export type AppInfosAction = AcceptCookieAction
	| SetAppTypeAppAction;

const getAppType = (): Promise<AppType> => {
	if (!UserAgentUtils.isMobileApp) {
		return Promise.resolve(AppType.Single);
	}

	return Utils.fetchText(`./.gallery/config/isMultiAppEnabled`, 'GET', undefined, true)
		.then(res => res === 'true' ? AppType.Multiple : AppType.Single)
		.catch(() => AppType.Single);
};

export const initializeApp = () => (dispatch: Dispatch<StoreState>): Promise<void | {}> => {
	return getAppType()
		.then(appType => {
			dispatch({ type: AppInfosActionKeys.SET_APP_TYPE, appType });

			if (appType === AppType.Multiple) {
				dispatch(initializeMultiAppAuthentication());
			}

			// check if it has has been fully initialized
			// if not, delete everything from file system & LocalStorage
		});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/App/actions.ts